var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlanReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.492,
    height: 28.621,
    viewBox: "0 0 28.492 28.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plan-review",
    transform: "translate(-352.62 17990.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M197.456,214.063H186.068a.773.773,0,0,1-.756-.785V192.754a.773.773,0,0,1,.756-.785h16.348a.773.773,0,0,1,.756.785v5.17a.757.757,0,1,0,1.512,0v-5.17a2.314,2.314,0,0,0-2.269-2.354H186.068a2.314,2.314,0,0,0-2.269,2.354v20.525a2.314,2.314,0,0,0,2.269,2.354h11.388a.785.785,0,0,0,0-1.569Z",
    transform: "translate(172.314 -18177.402)",
    fill: "#0000b5",
    stroke: "#0000b5",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M308.689,377.858l-3.252-3.358a6.126,6.126,0,1,0-1.055,1.018l3.259,3.361a.731.731,0,1,0,1.047-1.022Zm-8-2.56a4.65,4.65,0,1,1,4.65-4.65A4.657,4.657,0,0,1,300.692,375.3Zm-1.875-12.366a.735.735,0,0,0-.732-.732h-8.653a.732.732,0,0,0,0,1.465h8.653A.732.732,0,0,0,298.817,362.932Zm-4.449,4.075a.734.734,0,0,0-.732-.732h-4.2a.732.732,0,0,0,0,1.465h4.2A.73.73,0,0,0,294.368,367.008Zm-4.936,3.343a.732.732,0,1,0,0,1.465h2.259a.732.732,0,1,0,0-1.465Z",
    transform: "translate(71.966 -18342.295)",
    fill: "#0000b5",
    stroke: "#0000b5",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M186.636,214.063h-.453a.792.792,0,0,1-.794-.785V192.754a.792.792,0,0,1,.794-.785h17.169a.792.792,0,0,1,.794.785v.986a.794.794,0,0,0,1.588,0v-.986a2.37,2.37,0,0,0-2.382-2.354H186.182a2.37,2.37,0,0,0-2.382,2.354v20.525a2.37,2.37,0,0,0,2.382,2.354h.453a.785.785,0,1,0,0-1.569Z",
    transform: "translate(168.945 -18180.541)",
    fill: "#0000b5",
    stroke: "#0000b5",
    strokeWidth: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanReview);
export default __webpack_public_path__ + "static/media/icon-plan-review.f0f970381b0f3d5b4915658e7e34316b.svg";
export { ForwardRef as ReactComponent };